import ApiClient from '../../services/apiClient';
import { IDataScopeLookupModel } from '../../interfaces/ILookup';
import { LookupDataEnums } from '../../utilities/Constants';
import { useQuery } from 'react-query';

const _apiClient = new ApiClient();

export const useGetDataScopes = () => {
    return useQuery({
        queryKey: ['get-data-scopes'],
        queryFn: async () => {
            const response = await _apiClient.getLookupData(LookupDataEnums.DataScopes);
            
            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error(`Failed to retrieve lookup data scopes`);
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            //// This is necessary to get the UI typed for the generic lookup model when extended properties comes from the API
            const unTypedDataScopes: any = response.payload;
            const typedDataScopes: IDataScopeLookupModel[] = unTypedDataScopes;
            return typedDataScopes;
        },
        staleTime: Infinity,
        cacheTime: Infinity,
    });
};
